// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oc-1";
export var messageSideRight = "_oc-2";
export var orderLookupBubbleContainer = "_oc-0";
export var submitButton = "_oc-3";